function normalizeRoutePath(parentPath, routePath) {
  if (!routePath) {
    return parentPath || '/'
  }
  if (routePath.startsWith('/')) {
    return routePath
  }
  return `${parentPath || ''}/${routePath}`.replace(/\/+/g, '/')
}

export function hasRoutePermission(route, permissionCodes) {
  const codes = permissionCodes || []
  const meta = route && route.meta ? route.meta : {}
  const requiredCodes = [
    meta.permission,
    ...(Array.isArray(meta.permissions) ? meta.permissions : [])
  ].filter(Boolean)
  return requiredCodes.every(code => codes.includes(code))
}

export function findFirstAccessibleMenuPath(routes, permissionCodes, parentPath = '') {
  for (const route of routes || []) {
    if (!route || (route.meta && (route.meta.public || route.meta.hidden))) {
      continue
    }
    const currentPath = normalizeRoutePath(parentPath, route.path)
    if (Array.isArray(route.children) && route.children.length) {
      const childPath = findFirstAccessibleMenuPath(route.children, permissionCodes, currentPath)
      if (childPath) {
        return childPath
      }
    }
    if (hasRoutePermission(route, permissionCodes)) {
      return currentPath
    }
  }
  return ''
}

export function getDefaultAccessiblePath(routes, permissionCodes) {
  const root = (routes || []).find(route => route && route.path === '/')
  if (root && Array.isArray(root.children)) {
    return findFirstAccessibleMenuPath(root.children, permissionCodes, '')
  }
  return findFirstAccessibleMenuPath(routes, permissionCodes, '')
}
